import React, { useState, useEffect } from 'react';

const RenderTandC = () => {
  const [text1, setText1] = useState('');
  const [text2, setText2] = useState('');
  const [text3, setText3] = useState('');

  // Fetch initial data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://admindashboard.clns.in/api/dash/tandc/');
        const result = await response.json();
        
        if (result.status && result.data) {
          setText1(result.data.context1);
          setText2(result.data.context2);
          setText3(result.data.context3);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  // Handle text changes
  const handleTextChange1 = (e) => setText1(e.target.value);
  const handleTextChange2 = (e) => setText2(e.target.value);
  const handleTextChange3 = (e) => setText3(e.target.value);

  // Submit data to API
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const data = {
      context1: text1,
      context2: text2,
      context3: text3,
    };

    try {
      const response = await fetch('https://admindashboard.clns.in/api/dash/tandc/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (result.status) {
        alert('Changes saved successfully!');
      } else {
        alert('Failed to save changes. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting data:', error);
      alert('An error occurred while submitting data.');
    }
  };

  return (
    <div style={{ display: 'grid', padding: '10px' }}>
      <form onSubmit={handleSubmit}>
        <label
          style={{
            display: 'block',
            marginBottom: '10px',
            fontWeight: 'bold',
          }}
        >
          Write About Team CSLN
        </label>
        <div className="grid-container">
          <div>
            <textarea
              style={{ width: '100%' }}
              value={text1}
              onChange={handleTextChange1}
              placeholder="Context 1"
            />
          </div>
          <div>
            <textarea
              style={{ width: '100%' }}
              value={text2}
              onChange={handleTextChange2}
              placeholder="Context 2"
            />
          </div>
          <div>
            <textarea
              style={{ width: '100%' }}
              value={text3}
              onChange={handleTextChange3}
              placeholder="Context 3"
            />
          </div>
        </div>
        <button
          type="submit"
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginTop: '10px',
          }}
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default RenderTandC;
